$(document).ready(function () {
    if ($('.calendar-widget').length) {
        years = $('.calendar-widget tr.settings td.year select');

        for (var i = 1950; i <= 2050; i++) {
            years.append('<option value="' + i + '">' + i + "</option>");
        }

        $('.calendar-widget tr.settings .calendar-type').on('change', function () {
            if ($(this).is(':checked')) {
                $(this).parent().attr('title', 'Broadcast')
                    .tooltip('fixTitle')
                    .tooltip('show');
            } else {
                $(this).parent().attr('title', 'Gregorian')
                    .tooltip('fixTitle')
                    .tooltip('show');
            }
        });

        calendar_set_inputs();
        build_calendar();
    }
});

var calendar = $('.calendar-widget');

if (calendar.length) {
    var month = moment().startOf('month');
    var broadcast = true;

    $('.calendar-widget i.next').on('click', function () {
        month = month.add(1, 'months');
        calendar_set_inputs();
        build_calendar();
    });

    $('.calendar-widget i.previous').on('click', function () {
        month = month.subtract(1, 'months');
        calendar_set_inputs();
        build_calendar();
    });

    $('.calendar-widget .settings .submit button').on('click', function () {
        month = moment().month($('.calendar-widget .settings .month select').val())
            .year($('.calendar-widget .settings .year select').val()).startOf('month');

        if ($('.calendar-widget tr.settings .calendar-type').is(':checked')) {
            broadcast = true;
        } else {
            broadcast = false;
        }

        build_calendar();
    });

    $('.calendar-widget .settings-trigger').on('click', function () {
        if ($('.calendar-widget .settings').is(':visible')) {
            $(this).find('i').removeClass().addClass('fa fa-chevron-down p-l-10');
            $('.calendar-widget .settings').hide();
        } else {
            $(this).find('i').removeClass().addClass('fa fa-chevron-up p-l-10');
            $('.calendar-widget .settings').show();
        }
    });

    var build_calendar = function () {
        calendar.find('tr.heading td div.month span').html(month.format('MMMM YYYY'));

        var start = moment(month).startOf('isoweek');

        var end = moment(month).endOf('month').endOf('isoweek');

        var table = calendar.find('tbody');

        var x = 0;

        $(table).find('tr.days').remove();

        while (start < end) {

            if (x == 0) {
                $(table).append('<tr class="days"></tr>');
            }

            if (start.month() !== month.month()) {
                $(table).find('tr:last-child').append('<td class="day inactive">' + start.format('DD') + '</td>');
            } else if (start.format('YYYY MM DD') == moment().format('YYYY MM DD')) {
                $(table).find('tr:last-child').append('<td class="day active">' + start.format('DD') + '</td>');
            } else {
                $(table).find('tr:last-child').append('<td class="day">' + start.format('DD') + '</td>');
            }

            if (broadcast) {
                // This will break the loop on the broadcast month
                if ((start.day() == 0) && (moment(start).add(7, 'day').month() !== start.month())) {
                    break;
                }
            }

            start.add(1, 'day');

            x++;
            if (x == 7) {
                x = 0;
            }
        }
    };

    var calendar_set_inputs = function () {
        $('.calendar-widget tr.settings td.month select').val(month.month());
        $('.calendar-widget tr.settings td.year select').val(month.year());
    };
}
